const FORMATOS = [
  ["normal", "ocultarNormal"],
  ["polaroid", "ocultarPolaroid"],
  ["fotos_3x4", "ocultar3x4"],
  ["passaporte", "ocultarPassaporte"],
];

function configuracao(totem) {
  const config = totem?.config;
  return config && typeof config === "object" && !Array.isArray(config)
    ? config
    : null;
}

export function temConfiguracaoTotem(totem) {
  return configuracao(totem) !== null;
}

export function temConfiguracaoFormatos(totem) {
  const config = configuracao(totem);
  return (
    !!config && FORMATOS.some(([campo]) => typeof config[campo] === "boolean")
  );
}

export function temFormatoDisponivel(totem) {
  const config = configuracao(totem);
  return (
    !!config &&
    FORMATOS.some(
      ([campo, ocultar]) => config[campo] === true && !config[ocultar]
    )
  );
}

export function temCamadaManutencao(totem) {
  const config = configuracao(totem);
  if (!config) return false;
  return (
    config.bloqueio_financeiro === true ||
    config.bloqueio_suporte === true ||
    config.bloqueio_sem_formato === true ||
    config.bloqueio_papel_manutencao === true ||
    config.bloqueio_impressora_manutencao === true ||
    (typeof config.operacoes_massa?.manutencao === "string" &&
      !!config.operacoes_massa.manutencao)
  );
}

/** Estado local: nunca altera a intenção/camadas publicadas no Firebase. */
export function manutencaoEfetiva(totem) {
  const config = configuracao(totem);
  if (!config) return false;
  if (config.manutencao === true || temCamadaManutencao(totem)) return true;
  // Uma configuração inicial sem flags de formato é inválida, não uma
  // desativação conhecida. O init mantém sua tela de erro específica.
  if (!temConfiguracaoFormatos(totem)) return false;
  return !temFormatoDisponivel(totem);
}

export function podeLiberarManutencao(totem) {
  return (
    configuracao(totem)?.manutencao === false &&
    temFormatoDisponivel(totem) &&
    !manutencaoEfetiva(totem)
  );
}

export function preservarConfiguracaoOperacional(payload, anterior) {
  const config = configuracao(payload);
  const ultima = configuracao(anterior);
  if (!ultima) return payload;
  const campos = ["manutencao", ...FORMATOS.flat()];
  let efetiva = config;
  for (const campo of campos) {
    if (
      typeof config?.[campo] !== "boolean" &&
      typeof ultima[campo] === "boolean"
    ) {
      if (efetiva === config) efetiva = { ...(config || {}) };
      efetiva[campo] = ultima[campo];
    }
  }
  return efetiva === config ? payload : { ...payload, config: efetiva };
}
